import { createUrlFromBase64 } from '../../../helpers/attachments/createUrlFromBase64';

export const createAttachmentUrl = async (
  getAttachment,
  fileName,
  mimeType
) => {
  const data = await getAttachment({ fileName });

  return data === 'Error'
    ? { status: 'error', message: 'Не удалось получить данные файла' }
    : { status: 'success', ...createUrlFromBase64(data, mimeType) };
};
